import { cn } from '~/utils/cn'

export function UnderlinedTab({
  active,
  onClick,
  children,
  badgeText,
  className,
}: {
  children: React.ReactNode
  active?: boolean
  onClick?: () => void
  badgeText?: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'relative flex items-center gap-2.5 border-b-2 pb-2.5 px-2 cursor-pointer hover:border-primary-500 transition-colors',
        {
          'text-[#707070] border-[#A9A9A9]': !active,
          'text-primary-500 border-primary-500': active,
        },
        className
      )}
      onClick={onClick}
    >
      <h3 className={cn('text-lg font-semibold')}>{children}</h3>
      {badgeText && (
        <div
          className={cn(
            'hidden sm:flex items-center px-2 py-1 rounded-md bg-[#F4F6F7] text-xs',
            {
              'text-[#A9A9A9]': !active,
              'text-primary-500': active,
            }
          )}
        >
          {badgeText}
        </div>
      )}
    </div>
  )
}
